import React from "react";
import { useTranslation } from "react-i18next";

import Swal from "sweetalert2";

import { countryPhoneCodes } from "utils/constants";

import FormValidation from "./FormValidation";

function RegistrationForm({
  index,
  formValues,
  handleFormInput,
  isRegistrationFormValid,
  genderOptions,
  jerseySizeOptions,
  formErrors,
  onSizeChange,
  gloveSizeOptions,
  swingSpeedOptions,
  preferenceOptions,
  participantCategoryOptions,
}) {
  const { t } = useTranslation();

  // remove duplicate codes
  const newCountryPhoneCodes = countryPhoneCodes.filter(
    (value, index, self) =>
      index === self.findIndex((t) => t.code === value.code),
  );

  // open chart size
  const openChartSize = () => {
    // TODO: this used to show GNG's own polo-shirt size chart image. Add a
    // Topgolf Tournament 2026 size chart (imageUrl: "/size-chart.jpg" or similar)
    // once one exists, or remove this button if merch sizing isn't offered.
    // Swal.fire({
    //   title: t("productSize") || "Size Chart",
    //   text: "Size chart coming soon.",
    //   showConfirmButton: true,
    //   showCloseButton: true,
    // });
    Swal.fire({
      imageUrl:
        "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/0d2b358f022b7f19848637af33f544494802d9637f481392ab8100aaca67210af939a4f3d939df1c725512a0194d610593a37c10b7890a52925d683db053f3910da335cbdb2f30e90241c47f08ce983d8b365337d846b8b3cdf3100bb030a2e1403777630adff7dc898a249a7ba6d6f624cb7d2adbf9ec2f9591/file-1785737536057.jpeg", // for men only
      // "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/ea90518ea2ec8d5d444a28dcc1823754c7f1078e425a160abfda8f9195703db243f538708f80de79595eaaeaa7a91686ba9adaabfa9f1ca1cb9b44b5fb0a5bdf9ebf00279c0668fdff5cbb6f13b37479c8724479056147e688df71a5abb0380b23828fd4928feef262ea620f0b2898c411eaf5599f0f0473e418/file-1785732193563.jpeg", // for men and women
      imageAlt: "polo-shirt-chart-size",
      showConfirmButton: false,
      showCloseButton: false,
    });
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-6 gap-x-8 gap-y-4">
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel13")} *
        </label>
        <div className="flex w-full p-2 mt-1 text-gray-900 bg-white border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          <select
            onChange={handleFormInput}
            value={formValues[`participant-category-${index}`]}
            name={`participant-category-${index}`}
            className="w-full text-sm font-bold outline-none select-none"
            style={{
              color: !formValues[`participant-category-${index}`]
                ? "#9ca3af"
                : "#000000",
              fontWeight: "400",
            }}
          >
            <option value="" disabled selected>
              {t("inputSelectPlaceholder")}
            </option>
            {participantCategoryOptions.map((participantCategory, idx) => (
              <option key={idx} value={participantCategory.value}>
                {participantCategory.name}
              </option>
            ))}
          </select>
        </div>
        {formValues[`participant-category-${index}`] &&
        formValues[`participant-category-${index}`] !== "Mandiri" &&
        formValues[`participant-category-${index}`] !== "Topgolf" ? (
          <div className="mt-1">
            <input
              onChange={handleFormInput}
              value={formValues[`participant-category-other-${index}`]}
              placeholder={t("contactFormPlaceholder13")}
              type="text"
              name={`participant-category-other-${index}`}
              className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        ) : null}
        <FormValidation
          errorType={
            formErrors[`participant-category-${index}`] ||
            formErrors[`participant-category-other-${index}`]
          }
          showError={!isRegistrationFormValid}
        />
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel1")} *
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`customer-name-${index}`]}
            placeholder={t("contactFormPlaceholder1")}
            type="text"
            name={`customer-name-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
          <FormValidation
            errorType={formErrors[`customer-name-${index}`]}
            showError={!isRegistrationFormValid}
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel2")} *
        </label>
        <div className="mt-1">
          <input
            onChange={handleFormInput}
            value={formValues[`customer-email-${index}`]}
            placeholder={t("contactFormPlaceholder2")}
            type="text"
            name={`customer-email-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
          <FormValidation
            errorType={formErrors[`customer-email-${index}`]}
            showError={!isRegistrationFormValid}
          />
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel10")} *
        </label>
        <div className="flex w-full p-2 mt-1 text-gray-900 bg-white border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          <select
            onChange={handleFormInput}
            value={formValues[`gender-${index}`]}
            name={`gender-${index}`}
            className="w-full text-sm font-bold outline-none select-none"
            style={{
              color: !formValues[`gender-${index}`] ? "#9ca3af" : "#000000",
              fontWeight: "400",
            }}
          >
            <option value="" disabled selected>
              {t("inputSelectPlaceholder")}
            </option>
            {genderOptions.map((gender, idx) => (
              <option key={idx} value={gender.value}>
                {gender.name}
              </option>
            ))}
          </select>
        </div>
        <FormValidation
          errorType={formErrors[`gender-${index}`]}
          showError={!isRegistrationFormValid}
        />
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel7")} *
        </label>
        <div className="text-xs font-light text-red-500">
          {t("inputPhoneNumberExtraNote")}
        </div>
        <div className="flex w-full p-2 mt-1 text-gray-900 bg-white border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          {/* <select onChange={handleFormInput} value={formValues[`customer-phcode-${index}`]} name={`customer-phcode-${index}`} className='px-2 text-sm font-bold outline-none select-none w-fit'>
            <option value='' selected></option>
            {newCountryPhoneCodes.sort((a, b) => a.code - b.code).map(((country) => (
              <option value={country.code}>{country.code}</option>
            )))}
          </select> */}
          <span>+</span>(
          <input
            type="number"
            onChange={handleFormInput}
            value={formValues[`customer-phcode-${index}`]}
            name={`customer-phcode-${index}`}
            className="w-8 text-sm font-bold text-center outline-none select-none"
          />
          <span>)</span>
          <input
            onChange={handleFormInput}
            value={formValues[`phone-number-${index}`]}
            name={`phone-number-${index}`}
            placeholder={t("contactFormPlaceholder7")}
            type="number"
            min="0"
            className="block w-full pl-2 text-gray-900 border-0 outline-none placeholder:text-gray-400 sm:text-sm sm:leading-6"
          />
        </div>
        <FormValidation
          errorType={formErrors[`phone-number-${index}`]}
          showError={!isRegistrationFormValid}
        />
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel11")} *
        </label>
        <div className="flex w-full p-2 mt-1 text-gray-900 bg-white border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          <select
            onChange={(e) => {
              handleFormInput(e);
              onSizeChange(e.target.value, "jersey");
            }}
            value={formValues[`jersey-size-${index}`]}
            name={`jersey-size-${index}`}
            className="w-full text-sm font-bold outline-none select-none"
            style={{
              color: !formValues[`jersey-size-${index}`]
                ? "#9ca3af"
                : "#000000",
              fontWeight: "400",
            }}
          >
            <option value="" disabled selected>
              {t("inputSelectPlaceholder")}
            </option>
            {jerseySizeOptions.map((size, idx) => {
              if (size.stock) {
                return (
                  <option key={idx} value={size.value}>
                    {size.name}
                  </option>
                );
              } else {
                return null;
              }
            })}
          </select>
        </div>
        <FormValidation
          errorType={formErrors[`jersey-size-${index}`]}
          showError={!isRegistrationFormValid}
        />
        <div className="pt-1 text-xs font-light">
          {t("inputJerseySizeExtraNote")}{" "}
          <span className="text-xs font-light text-red-500">
            {t("inputJerseySizeExtraNote2")}
          </span>{" "}
          <span
            onClick={openChartSize}
            className="text-xs italic font-bold leading-6 text-gray-900 underline cursor-pointer"
          >
            {t("viewChartSize")}.
          </span>
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel12")} *
        </label>
        <div className="flex w-full p-2 mt-1 text-gray-900 bg-white border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          <select
            onChange={(e) => {
              handleFormInput(e);
              onSizeChange(e.target.value, "glove");
            }}
            value={formValues[`glove-size-${index}`]}
            name={`glove-size-${index}`}
            className="w-full text-sm font-bold outline-none select-none"
            style={{
              color: !formValues[`glove-size-${index}`] ? "#9ca3af" : "#000000",
              fontWeight: "400",
            }}
            disabled={!formValues[`gender-${index}`]}
          >
            <option value="" disabled selected>
              {t("inputSelectPlaceholder")}
            </option>
            {gloveSizeOptions.map((size, idx) => {
              if (size.stock) {
                return (
                  <option key={idx} value={size.value}>
                    {size.name}
                  </option>
                );
              } else {
                return null;
              }
            })}
          </select>
        </div>
        <FormValidation
          errorType={formErrors[`glove-size-${index}`]}
          showError={!isRegistrationFormValid}
        />
        <div className="pt-1 text-xs font-light">
          {t("inputJerseySizeExtraNote")}{" "}
          <span className="text-xs font-light text-red-500">
            {t("inputJerseySizeExtraNote2")}
          </span>
        </div>
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel3")} *
        </label>
        <div className="flex w-full p-2 mt-1 text-gray-900 bg-white border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          <select
            onChange={handleFormInput}
            value={formValues[`swing-speed-${index}`]}
            name={`swing-speed-${index}`}
            className="w-full text-sm font-bold outline-none select-none"
            style={{
              color: !formValues[`swing-speed-${index}`]
                ? "#9ca3af"
                : "#000000",
              fontWeight: "400",
            }}
          >
            <option value="" disabled selected>
              {t("inputSelectPlaceholder")}
            </option>
            {swingSpeedOptions.map((swingSpeed, idx) => (
              <option key={idx} value={swingSpeed.value}>
                {swingSpeed.name}
              </option>
            ))}
          </select>
        </div>
        <FormValidation
          errorType={formErrors[`swing-speed-${index}`]}
          showError={!isRegistrationFormValid}
        />
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel4")} *
        </label>
        <div className="flex w-full p-2 mt-1 text-gray-900 bg-white border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
          <select
            onChange={handleFormInput}
            value={formValues[`preference-${index}`]}
            name={`preference-${index}`}
            className="w-full text-sm font-bold outline-none select-none"
            style={{
              color: !formValues[`preference-${index}`] ? "#9ca3af" : "#000000",
              fontWeight: "400",
            }}
          >
            <option value="" disabled selected>
              {t("inputSelectPlaceholder")}
            </option>
            {preferenceOptions.map((preference, idx) => (
              <option key={idx} value={preference.value}>
                {preference.name}
              </option>
            ))}
          </select>
        </div>
        <FormValidation
          errorType={formErrors[`preference-${index}`]}
          showError={!isRegistrationFormValid}
        />
      </div>
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {t("contactFormLabel9")}
        </label>
        <div className="mt-1">
          <textarea
            rows={5}
            onChange={handleFormInput}
            value={formValues[`notes-${index}`]}
            placeholder={t("contactFormPlaceholder9")}
            type="text"
            name={`notes-${index}`}
            className="block w-full p-2 text-gray-900 border-0 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>
    </div>
  );
}

export default RegistrationForm;
